import { Injectable } from '@angular/core';
import {
  HttpRequest,
  HttpHandler,
  HttpEvent,
  HttpInterceptor
} from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';

import { UnexpectedErrorComponent } from '@ui/ui-errors';
import { UnexpectedErrorMessageService } from '@core/services';
import { HttpStatusCode } from '@core/enums/http-status-code';

import { AuthService } from '../services/auth.service';
import { UserMeModel } from '@core/api/model/userMeModel';
import { MatDialog } from '@angular/material';
import { ErrorScreenComponent } from '@ui/ui-errors/error-screen/error-screen.component';

const AllowStatuses = [
  HttpStatusCode.OK,
  HttpStatusCode.CREATED,

  HttpStatusCode.NO_CONTENT,

  HttpStatusCode.NOT_FOUND,
  HttpStatusCode.TOO_MANY_REQUEST,
  HttpStatusCode.UNPROCESSABLE_ENTITY,

  HttpStatusCode.CONFLICT
];

function isNotFoundEntity(status: HttpStatusCode, message: string): boolean {
  return status === HttpStatusCode.NOT_FOUND && message === 'Not Found';
}

function isNotAllowedStatus(status: HttpStatusCode): boolean {
  return !AllowStatuses.includes(status);
}

@Injectable()
export class ErrorInterceptor implements HttpInterceptor {
  constructor(
    private authService: AuthService,
    private snackBar: UnexpectedErrorMessageService,
    public dialog: MatDialog,
  ) { }

  intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    return next.handle(request).pipe(catchError(res => {

      const { status = HttpStatusCode.INTERNAL_SERVER_ERROR, error = {} } = res;
      const { message = 'Internal Server Error', success: successResponse } = error;

      if (status === HttpStatusCode.UNAUTHORIZED) {
        this.authService.reset();
        location.reload();
      }


      if (successResponse === undefined || isNotAllowedStatus(status) || isNotFoundEntity(status, message)) {
        if ((!this.authService.currentRole || this.authService.currentRole.name == UserMeModel.RoleEnum.GUEST || this.authService.currentRole.name == UserMeModel.RoleEnum.USER)) {
          this.dialog.open(ErrorScreenComponent, {
            panelClass: 'full-screen-modal',
          });
        } else {
          this.snackBar.openFromComponent(UnexpectedErrorComponent);
        }

      }

      return throwError({
        ...error,
        status
      });
    }));
  }
}
